module.exports = __webpack_public_path__ + "static/media/logo-genesis-positive.14bea002.png";